// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.core-form-dual-action-backdrop {
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 60;
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
}

.core-form-dual-action-frame {
    position: fixed;
    background: linear-gradient(to bottom right, var(--color-primaryDark), var(--color-grey900));
    border-radius: 5px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-height: 40%;
    max-height: 70%;
    width: 50%;
    z-index: 70;
    padding-top: 75px;
    padding-left: 75px;
    padding-right: 75px;
    padding-bottom: 75px;
    display: flex;
    flex-direction: column;
}

.core-form-dual-action-content {
    color: var(--color-grey000);
    overflow-y: scroll;
    flex-grow: 1;
}

.core-form-dual-action-title {
    padding: 0;
    padding-bottom: 30px;
    margin: 0;
    color: var(--color-grey000);
}

.core-form-dual-action-start-line {
    margin-top: 20px;
    border-top: 3px solid var(--color-grey000);

}

.core-form-dual-action-end-line {
    margin-top: 20px;
    border-top: 3px solid var(--color-grey000);
}

.core-form-dual-action-buttons-section {
    padding-top: 40px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    z-index: 70;
    /* Increased z-index to ensure visibility above the backdrop */
}

.core-form-dual-action-primary-button {
    width: calc(70% - 0.5rem);
    /* 0.25rem is half the margin to account for spacing */
}

.core-form-dual-action-secondary-button {
    width: calc(30% - 0.5rem);
    /* 0.25rem is half the margin to account for spacing */
    margin-right: 0.5rem;
    /* Creates space between the two buttons */
}

@media (max-width: 1200px) {
    .core-form-dual-action-frame {
        width: 75%;
        padding-top: 30px;
        padding-left: 20px;
        padding-right: 20px;
        padding-bottom: 40px;
    }
    .core-form-dual-action-title {
        font-size: 14pt;
        padding-bottom: 0px;
    }
    .core-form-dual-action-content {
        font-size: 10pt;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/core/form/CoreFormDualAction.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,WAAW;IACX,kCAA0B;YAA1B,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,4FAA4F;IAC5F,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,eAAe;IACf,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,oBAAoB;IACpB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,0CAA0C;;AAE9C;;AAEA;IACI,gBAAgB;IAChB,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,WAAW;IACX,8DAA8D;AAClE;;AAEA;IACI,yBAAyB;IACzB,sDAAsD;AAC1D;;AAEA;IACI,yBAAyB;IACzB,sDAAsD;IACtD,oBAAoB;IACpB,0CAA0C;AAC9C;;AAEA;IACI;QACI,UAAU;QACV,iBAAiB;QACjB,kBAAkB;QAClB,mBAAmB;QACnB,oBAAoB;IACxB;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".core-form-dual-action-backdrop {\n    position: fixed;\n    top: 0;\n    right: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    z-index: 60;\n    backdrop-filter: blur(5px);\n}\n\n.core-form-dual-action-frame {\n    position: fixed;\n    background: linear-gradient(to bottom right, var(--color-primaryDark), var(--color-grey900));\n    border-radius: 5px;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    min-height: 40%;\n    max-height: 70%;\n    width: 50%;\n    z-index: 70;\n    padding-top: 75px;\n    padding-left: 75px;\n    padding-right: 75px;\n    padding-bottom: 75px;\n    display: flex;\n    flex-direction: column;\n}\n\n.core-form-dual-action-content {\n    color: var(--color-grey000);\n    overflow-y: scroll;\n    flex-grow: 1;\n}\n\n.core-form-dual-action-title {\n    padding: 0;\n    padding-bottom: 30px;\n    margin: 0;\n    color: var(--color-grey000);\n}\n\n.core-form-dual-action-start-line {\n    margin-top: 20px;\n    border-top: 3px solid var(--color-grey000);\n\n}\n\n.core-form-dual-action-end-line {\n    margin-top: 20px;\n    border-top: 3px solid var(--color-grey000);\n}\n\n.core-form-dual-action-buttons-section {\n    padding-top: 40px;\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    z-index: 70;\n    /* Increased z-index to ensure visibility above the backdrop */\n}\n\n.core-form-dual-action-primary-button {\n    width: calc(70% - 0.5rem);\n    /* 0.25rem is half the margin to account for spacing */\n}\n\n.core-form-dual-action-secondary-button {\n    width: calc(30% - 0.5rem);\n    /* 0.25rem is half the margin to account for spacing */\n    margin-right: 0.5rem;\n    /* Creates space between the two buttons */\n}\n\n@media (max-width: 1200px) {\n    .core-form-dual-action-frame {\n        width: 75%;\n        padding-top: 30px;\n        padding-left: 20px;\n        padding-right: 20px;\n        padding-bottom: 40px;\n    }\n    .core-form-dual-action-title {\n        font-size: 14pt;\n        padding-bottom: 0px;\n    }\n    .core-form-dual-action-content {\n        font-size: 10pt;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
